import { useMemo } from 'react';
import { prop } from 'ramda';

import { useGameConfigurationSelector } from '@core/js/store/hooks';

import { TAvailableDataGame } from '../types';

export const useAvailableGames = () => {
    const games = useGameConfigurationSelector(prop('games'));

    return useMemo(() => {
        if (!games) {
            return [];
        }

        return Object.keys(games)
            .reduce<TAvailableDataGame[]>((acc, code) => {
                const { name } = games[code];

                acc.push({
                    id: code,
                    value: name
                });

                return acc;
            }, []);
    }, [games]);
};
